import { render, staticRenderFns } from "./PanelDerecho.vue?vue&type=template&id=4db96766&"
import script from "./PanelDerecho.vue?vue&type=script&lang=js&"
export * from "./PanelDerecho.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports